import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "@authentication/auth.service";
import { TipoUsuario } from "@shared/enums/tipoUsuario";
import { EstadoCliente } from "@shared/enums/EstadoCliente";
import { SaldoCliente } from '@shared/models/controlCredito/SaldoCliente';
import { ControlCreditoService } from "@controlCredito/control-credito.service";
import { ErrorModel } from "@shared/models/ErrorModel";
import { ModalSolicitarCreditoComponent } from "@controlCredito/reportes/modales/modal-solicitar-credito/modal-solicitar-credito.component";
import { ModalCrearNotificacionComponent } from "@controlCredito/reportes/modales/modal-crear-notificacion/modal-crear-notificacion.component";
import { ConfiguracionBloqueoAutomaticoComponent } from "@controlCredito/reportes/modales/configuracion-bloqueo-automatico/configuracion-bloqueo-automatico.component";
import { MessageService } from "@shell/message.service";

@Component({
  selector: 'app-reporte-saldo-detalle',
  templateUrl: './reporte-saldo-detalle.component.html',
  styleUrl: './reporte-saldo-detalle.component.scss'
})
export class ReporteSaldoDetalleComponent implements OnInit {
  @Input() cliente!: SaldoCliente;
  @Input() i!: number;
  @Input() bloquear!: boolean;
  @Input() cargandoConfiguracion!: boolean[];
  @Input() cargandoNotificacion!: boolean[];
  @Input() actualiza!: boolean;
  @Input() seleccionado!: number;
  @Input() idNotificacionSaldos!: string;
  @Output() bloquearActualizar: EventEmitter<boolean>= new EventEmitter<boolean>();
  TipoUsuario = TipoUsuario;
  EstadoCliente = EstadoCliente;

  constructor(private controlCreditoService: ControlCreditoService, public authService: AuthService,
              private modalService: NgbModal, private modal: NgbModal, private messageService: MessageService) {}

  ngOnInit() {
    this.bloquearActualizar.emit(false);
  }

  solicitar(cliente: SaldoCliente) {
    const modalRef = this.modalService.open(ModalSolicitarCreditoComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.cliente = cliente;
  }

  agregarNotificacion(i, cliente: SaldoCliente) {
    const modalRef = this.modal.open(ModalCrearNotificacionComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.cliente = cliente;
    modalRef.componentInstance.idNotificacionSaldos = this.idNotificacionSaldos;
    modalRef.componentInstance.index = i;
  }

  modificarConfiguracion(cliente: SaldoCliente) {
    const modalRef = this.modalService.open(ConfiguracionBloqueoAutomaticoComponent);
    modalRef.componentInstance.cliente = {
      razonSocial: cliente.clienteRazonSocial,
      id: cliente.clienteId,
      cuit: cliente.clienteCuit
    };
    modalRef.componentInstance.configuracion = cliente.configuracionBloqueo;
    modalRef.result.then(value => {
      if (value) {
        cliente.configuracionBloqueo = value;
      }
    });
  }

  actualizarSaldo(clienteSaldo: SaldoCliente, index): void {
    this.seleccionado = index;
    this.bloquear = true;
    this.actualiza = true;
    this.bloquearActualizar.emit(true);
    const tipoDocumento = clienteSaldo.tipoDocumento;
    const numeroDocumento = clienteSaldo.clienteCuit;
    this.controlCreditoService.actualizarSaldo(tipoDocumento, numeroDocumento).subscribe(cliente => {
      clienteSaldo.limite = cliente.limite;
      clienteSaldo.saldoPAD = cliente.saldoPAD;
      clienteSaldo.saldo = cliente.saldo;
      clienteSaldo.excedido = cliente.excedido;
      clienteSaldo.excedidoAutorizado = cliente.excedidoAutorizado;
      clienteSaldo.situacionExcedido = cliente.situacionExcedido;
      clienteSaldo.saldoVencido = cliente.saldoVencido;
      clienteSaldo.situacionVencido = cliente.situacionVencido;
      clienteSaldo.vencidoAutorizado = cliente.vencidoAutorizado;
      clienteSaldo.ultimoEstadoCliente = cliente.ultimoEstadoCliente;
      clienteSaldo.estadoCrediticio = cliente.estadoCrediticio;
      clienteSaldo.solicitudesCrediticias = cliente.solicitudesCrediticias;
      this.bloquear = false;
      this.actualiza = false;
      this.bloquearActualizar.emit(false);
      this.seleccionado = null;
    }, (err: ErrorModel) => {
      this.messageService.showErrorMessage('No se pudo actualizar el saldo: ' + err.description);
      this.bloquearActualizar.emit(false);
      this.bloquear = false;
      this.actualiza = false;
      this.seleccionado = null;
    });
  }
}
